.bar_performanceItem:hover {
  background-color: light-dark(var(--mantine-color-primary-2), var(--mantine-color-primary-5)) !important;
}
